<template lang="pug">
.generic-wrapper
  .container
    .card.margin-top
      .main
        .left
          h1.title Ahoi Matrose!
          .sub-headline Bitte füllen Sie alle erforderlichen Felder aus, um sich einzuloggen.
          ValidationObserver(v-slot="{ handleSubmit }")
              .form
                ValidationProvider(name="Benutzername" rules="required|min:3" v-slot="{ errors, valid }")
                  b-field(label="Benutzername" label-position="on-border"
                          :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                    b-input(v-model="formData.username")

                ValidationProvider(name="Passwort" rules="required" v-slot="{ errors, valid }")
                  b-field(label="Passwort" label-position="on-border"
                          :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                    b-input(type="password" v-model="formData.password" @keyup.native.enter="handleSubmit(login)")

              .button-wrapper
                b-button(type="is-primary" @click="handleSubmit(login)") Einloggen

          p Sie möchten einen Account erstellen? 
            a(@click="$router.push({name: 'SignUp'})") Dann klicken Sie hier.

        .right
          .logo-image
            img(src="@/assets/logo.svg")
          .logo-slogan Die nächste Generation der Vermietungsportale für die Ferienvermietung.

</template>

<script>
export default {
  data() {
    return {
      formData: {
        username: "",
        password: ""
      }
    };
  },
  methods: {
    async login() {
      await this.$store.dispatch("auth/login", this.formData);
      this.$router.push({ name: "Dashboard" });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 80px);
}

.card {
  overflow: hidden;
}

.main {
  display: flex;
  justify-content: space-between;
  .left,
  .right {
    width: 100%;
  }

  .left {
    padding: $lg-space $md-space;
    .form {
      margin-top: $lg-space;
      margin-bottom: $sm-space;
    }

    p {
      margin-top: $sm-space;
    }
  }

  .right {
    background-color: $danger;
    background: linear-gradient(45deg, $danger, lighten($danger, 8%));
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .logo-image {
      padding: $sm-space;
      box-shadow: $shadow-lg;
      background-color: white;
      border-radius: 6px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .logo-slogan {
      padding: $md-space;
      color: white;
      letter-spacing: 0.05em;
      text-transform: uppercase;
      font-size: 1rem;
      font-weight: 500;
      text-align: center;
    }
  }
}
</style>